import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { Query } from "react-apollo";

import ErrorBoundary from "components/Library/ErrorBoundary";
import AUTHOR_STREAM_HELMET_QUERY from "./AuthorStreamHelmet.graphql";
import { FRONTEND_ROOT } from "config/constants";

export default function AuthorStreamHelmet({ username }) {
  return (
    <ErrorBoundary>
      <Query query={AUTHOR_STREAM_HELMET_QUERY} variables={{ username }}>
        {({ loading, data }) => {
          if (loading) return null;

          const { author } = data;
          return (
            <Helmet>
              <title>{author.display_name} - Axios</title>
              <meta
                property="og:url"
                content={`${FRONTEND_ROOT}/authors/${author.username}/`}
              />
              <meta
                property="og:title"
                content={`${author.display_name} on Axios`}
              />
            </Helmet>
          );
        }}
      </Query>
    </ErrorBoundary>
  );
}

AuthorStreamHelmet.propTypes = {
  username: PropTypes.string.isRequired,
};
